// extracted by mini-css-extract-plugin
export default {"reports":"Reports_reports__sGpev","report":"Reports_report__gigLg","reportValue":"Reports_reportValue__gNeih"};